import { Component, Input, OnInit, AfterViewChecked } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { APP_DATE_FORMATS } from '@root/custom-material/format-datepicker';
import { MatDatepickerInputEvent } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ControlFormsService } from '@services/control-forms.service';
 
@Component({
  selector: 'control-datepicker',
  templateUrl: './control-datepicker.component.html',
  styleUrls: ['./control-datepicker.component.scss'],
  providers: [
    // {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class ControlDatepickerComponent implements OnInit, AfterViewChecked {
 
  @Input('sfcontrol')  _sfcontrol: SpecialFormControl;
  public maxDate= new Date();
  
  public set sfcontrol(control : SpecialFormControl) {
    if (control) {
      this._sfcontrol = control;
    }
  }
  public get sfcontrol(): SpecialFormControl {
    if (this._sfcontrol.value) {
      return this._sfcontrol;
    }
  }

  private _finisher = new Subject<void>();
  @Input() hidding: boolean = false;
 
  constructor(
    private _controlFormsService: ControlFormsService,

  ) { 
    this._controlFormsService.itemValueDataPicker.pipe(takeUntil(this._finisher)).subscribe((nextValue) => {
      if(!nextValue){
        this.hidding = true;
      }
    });   
  }
 
  ngOnInit(){
 
  }

  ngAfterViewChecked(){
    /* if(this._sfcontrol.value){
      let startDate = moment(this._sfcontrol.value).add(1, 'day').format('YYYY-MM-DD')
      this._sfcontrol.setValue(new Date(startDate))
    } */
  }
  
  change(data: MatDatepickerInputEvent<Date>) {
    if (data) {
      this._sfcontrol.setValue(data.value);
    }
    
  }
}